import type { ReceiptTemplate } from '../schema';

export const moneygramTemplate: ReceiptTemplate = {
  id: 'moneygram',
  name: 'MoneyGram Receipt',
  brand: 'MONEYGRAM',
  description: 'MoneyGram transfer receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'mg-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'MONEYGRAM',
        businessNameFontSize: 18,
        addressLines: ['MONEY TRANSFER RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'mg-ref',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'REFERENCE NUMBER\n84729103847', fontSize: 14, showDivider: true, dividerStyle: 'dashed', isBold: true },
    },
    {
      id: 'mg-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'sender', label: 'Sender:', value: 'JOHN DOE' },
          { id: 'receiver', label: 'Receiver:', value: 'MIKE WAZOWSKI' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'dest', label: 'Country:', value: 'PHILIPPINES' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'mg-amount',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'send', label: 'SEND AMOUNT', value: '500.00', isBold: false, isLarge: false },
          { id: 'fee', label: 'FEE', value: '12.99', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL PAID', value: '512.99', isBold: true, isLarge: true },
          { id: 'receive', label: 'RECEIVE AMOUNT', value: '₱28,250.00', isBold: false, isLarge: false },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'mg-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'SAVE THIS RECEIPT\nRECEIVER NEEDS REF NUMBER', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

